import axios from 'axios';
import { baseURL } from '../utility/Constants';

export const fetchBatteryMetrics = async (emsName, timeFilter, date) => {
  try {
    // Format the date properly
    const formattedDate = new Date(date).toISOString();
    const payload = {
      emsName,
      timeFilter,
      date: formattedDate
    };

    console.log('Sending request with payload:', payload);

    const response = await axios.post(`${baseURL}/battery-metrics`, payload);
    return response.data;
  } catch (error) {
    console.error('Error details:', {
      message: error.message,
      response: error.response?.data,
      payload: {
        emsName,
        timeFilter,
        date: date?.toString()
      }
    });
    throw error;
  }
};
